module.exports = __webpack_public_path__ + "cancellara-dist/img/best-sellers.f4610abb.jpg";